// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { Section } from '@atlaskit/menu';
import { N20, Y100 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RenotifyMessageContainer = styled(Section)({
  maxWidth: '300px',
  padding: "var(--ds-space-200, 16px)",
  backgroundColor: `var(--ds-background-accent-yellow-subtlest, ${Y100})`,
  '&::before': {
    height: "var(--ds-space-0, 0px)"
  },
  '&::after': {
    height: "var(--ds-space-0, 0px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RenotifyModalWidthFull = styled.div({
  width: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RenotifyModalUsersContainerOld = styled.div({
  height: '200px',
  maxHeight: '200px',
  overflowY: 'auto',
  marginTop: "var(--ds-space-200, 16px)",
  padding: "var(--ds-space-200, 16px)",
  paddingTop: "var(--ds-space-100, 8px)",
  border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-information, ${N20})`}`
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RenotifyModalUsersContainerNew = styled.div({
  height: 'fit-content',
  maxHeight: '174px',
  overflowY: 'auto',
  marginTop: "var(--ds-space-200, 16px)",
  paddingTop: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RenotifySpotlightTriggerChevron = styled.span({
  marginLeft: "var(--ds-space-negative-100, -8px)",
  marginRight: "var(--ds-space-negative-100, -8px)",
  opacity: 0.5
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RenotifySpotlightContent = styled.div({
  marginTop: "var(--ds-space-050, 4px)",
  marginBottom: "var(--ds-space-100, 8px)"
});